<template>
  <mdb-container fluid class="gp-has-header">
    <div v-show="showList">
      <data-table :actions="actions"
                  :force-query="forceQuery"
                  @handleAction="handleRowAction"
                  @forcedRowLoaded="forcedRowLoaded"
                  :show-add-button="true"
                  add-label="Submit a New Issue"
                  :add-handler="openNewIssue"
                  queryName="IssueQuery"
                  title-icon="bug"
                  pageTitle="Bugs & Enhancement Requests"/>

    </div>

    <div v-if="showIssue" class="text-left">

      <mdb-card class="mb-4">
        <mdb-card-header>
          <h5>Issue #{{ currentIssue.id }} - {{ currentIssue.title }}
            <mdb-badge v-if="currentIssue.userInfo.voted">
              <mdb-icon icon="star"/>
              Voted Yes
            </mdb-badge>
            <mdb-badge v-if="currentIssue.userInfo.watch">
              <mdb-icon icon="thumbtack"/>
              Following
            </mdb-badge>
            <mdb-badge v-if="currentIssue.userInfo.votes > 0">
              {{ currentIssue.userInfo.votes }} Vote{{ currentIssue.userInfo.votes > 1 ? 's' : '' }}
            </mdb-badge>
          </h5>
          <mdb-btn icon="arrow-left" rounded size="sm" @click="issueList"/>
          <mdb-btn icon="signal-3" rounded size="sm" @click="getStats">Stats</mdb-btn>
          <mdb-btn v-if="currentIssue.userInfo.voted" color="warning" fal icon="star" rounded size="sm"
                   @click="toggleVote(currentIssue.userInfo)">Remove Vote
          </mdb-btn>
          <mdb-btn v-if="!currentIssue.userInfo.voted" icon="star" rounded size="sm"
                   @click="toggleVote(currentIssue.userInfo)">Vote For This
          </mdb-btn>
          <mdb-btn v-if="currentIssue.userInfo.watch" color="warning" fal icon="thumbtack" rounded size="sm"
                   @click="toggleFollowing(currentIssue.userInfo)">Stop Following
          </mdb-btn>
          <mdb-btn v-if="!currentIssue.userInfo.watch" icon="thumbtack" rounded size="sm"
                   @click="toggleFollowing(currentIssue.userInfo)">Follow
          </mdb-btn>

        </mdb-card-header>
        <mdb-card-body>
          <div>
            <mdb-input id="yn-y" v-model="currentIssue.type" :disabled="!isAdmin" label="Bug" name="Yes-Radio"
                       radioValue="Bug"
                       type="radio"/>
            <mdb-input id="yn-n" v-model="currentIssue.type" :disabled="!isAdmin" label="Enhancement" name="No-Radio"
                       radioValue="Enhancement" type="radio"/>
          </div>
          <mdb-input v-model="currentIssue.title" :disabled="!isAdmin" label="Title" placeholder="Title"/>
          <gp-select id="issue-status" :dataObj="currentIssue" :disabled="!isAdmin" :possible-values="statuses"
                     :required="true"
                     label="Status" propertyName="status"/>
          <mdb-input v-model="currentIssue.statusDate" disabled label="Status Date" placeholder="Status Date"
                     type="text"/>
          <gp-select id="issue-priority" :dataObj="currentIssue" :disabled="!isAdmin" :possible-values="priorities"
                     :required="true"
                     label="Priority" propertyName="priority"/>
          <mdb-input v-model="currentIssue.releaseTarget" :disabled="!isAdmin"
                     :label="'Release Target (API) (Current is ' + this.release + ')'" placeholder="Target"
                     type="text"/>
          <mdb-input v-model="currentIssue.uiReleaseTarget" :disabled="!isAdmin"
                     :label="'Release Target (UI) (Current is ' + this.uiRelease + ')'" placeholder="Target"
                     type="text"/>
          <mdb-input v-if="isAdmin" id="isAdmin" v-model="currentIssue.isPrivate"
                     label="Private Issue?" name="isAdmin" type="checkbox"/>
          <editor v-model="currentIssue.description" :disabled="!isAdmin" :init="editorConfig"/>
          <mdb-btn v-if="isAdmin" color="success" icon="save" @click="saveIssue(false)">Save</mdb-btn>
          <mdb-btn v-if="isAdmin" color="warning" icon="save" @click="saveIssue(true)">Save Silently (No Notices)</mdb-btn>

        </mdb-card-body>
        <mdb-card-footer>
          <div><h6>Created on {{ currentIssue.opened }} By</h6>
            <mdb-chip :alt="currentIssue.author" :src="currentIssue.authorAvatar" waves>{{ currentIssue.author }}
            </mdb-chip>
          </div>
        </mdb-card-footer>
      </mdb-card>

      <messaging v-if="showIssue && currentIssue"
                 :id="currentIssue.id"
                 :allowReply="true"
                 type="issue"
      />
    </div>

    <div v-if="showCreate">
      <mdb-card>
        <mdb-card-header class="text-left" color="text-white">
          <h5>Submit New Bug Report or Enhancement Request</h5>
        </mdb-card-header>
        <mdb-card-body>
          <mdb-card class="mb-4" v-if="settings.issueFeature">
            <mdb-card-body class="text-left">
              <p>This form lets you submit a bug report or enhancement request. <b>Other users of the system will see
                your request.</b></p>
              <p><span class="text-warning"><b>Please do not use this form to ask for help</b></span> or to report a
                problem containing personal or
                sensitive information (like email addresses), or to report a vulnerability. Instead, send us a private
                message.
                <mdb-btn icon="envelope" rounded size="sm" @click="$router.push('/conversations/?start=1')">Send Private
                  Message
                </mdb-btn>
              </p>

            </mdb-card-body>
          </mdb-card>
          <mdb-card class="mb-4">
            <mdb-card-body>
              <gp-select :dataObj="newIssue" :possible-values="types" :required="true" label="Type"
                         propertyName="type"/>
              <mdb-input v-model="newIssue.title" label="Title" placeholder="Title"
                         type="text"/>

              <h4>Description of Issue</h4>
              <small>Hint: you may drag screenshots or other images into the editor box to help describe your
                issue.</small>
              <editor v-model="newIssue.description" :init="editorConfig"/>
            </mdb-card-body>
          </mdb-card>
          <mdb-btn :disabled="!newIssue.title||!newIssue.description" color="success" icon="save" @click="reportIssue">
            Submit
          </mdb-btn>
          <mdb-btn color="danger" icon="times-circle" @click="issueList">Cancel</mdb-btn>
        </mdb-card-body>
      </mdb-card>
    </div>

    <mdb-modal v-if="showStats" @close="showStats = false">
      <mdb-modal-header :close="true" class="primary-color text-white">
        Stats
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-tbl class="text-left" responsive striped>
          <mdb-tbl-head class="primary-color text-white">
            <tr>
              <th>User</th>
              <th>Voted</th>
              <th>Following</th>
            </tr>
          </mdb-tbl-head>
          <mdb-tbl-body>
            <tr v-for="(vote,i) in stats">
              <td>
                <mdb-chip :alt="vote.name" :src="vote.avatar" waves>{{ vote.name }}
                </mdb-chip>
              </td>
              <td>
                <mdb-badge v-if="vote.voted">
                  <mdb-icon icon="check"/>
                </mdb-badge>
              </td>
              <td>
                <mdb-badge v-if="vote.following">
                  <mdb-icon icon="check"/>
                </mdb-badge>
              </td>
            </tr>
          </mdb-tbl-body>
        </mdb-tbl>

      </mdb-modal-body>
    </mdb-modal>

  </mdb-container>
</template>

<script>
import api from '../services/groupsPlaceApi'
import UserContent from "./common/UserContent";
import gpSelect from "./common/GPSelect";
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbChip,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbMasonry,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbPanel,
  mdbRow,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';
import messaging from "./common/Messaging";
import editor from '@tinymce/tinymce-vue'
import DataTable from "./common/DataTableAdvanced";

export default {
  name: 'Issue',
  components: {
    mdbBtn,
    mdbContainer,
    mdbBadge,
    mdbIcon,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    mdbPanel,
    mdbChip,
    mdbMasonry,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardFooter,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbModalFooter,
    mdbRow,
    mdbCol,
    mdbInput,
    messaging,
    UserContent,
    gpSelect,
    editor,
    DataTable
  },
  computed: {
    isAdmin: function() {
      return this.userDetails.issueTracker
    },
    filterDisplay: function () {
      for (let i = 0; i < this.filters.length; i++) {
        if (this.filter == this.filters[i].value) return this.filters[i].label
      }
      return ""
    },
    settings() {
      return this.$store.state.settings
    },
    userDetails() {
      return this.$store.state.userDetails
    },
  },
  beforeRouteLeave(to, from, next) {
    if ((this.showIssue || this.showCreate) && to.name == this.enteredFrom) {
      next(false)
      this.issueList()
    } else next()
  },
  beforeRouteEnter(to, from, next) {
    if (from) {
      next(vm => {
        vm.enteredFrom = from.name  //save where we came from
      })
    }
  },

  data() {
    return {
      actions: [
        {name: "view", label: "View Details", color: 'success', icon: "clipboard"}
      ],
      forceQuery: null,
      query: "",
      showList: true,
      showIssue: false,
      currentIssue: null,
      isTyping: false,
      scrollEvent: null,
      listScrollPos: 0,
      filter: "open",
      showFilters: false,
      showCreate: false,
      newIssue: {},
      showStats: false,
      stats: [],
      release: null,
      uiRelease: null,
      editorConfig: {
        browser_spellcheck: true,
        branding: false,
        plugins: ["image", "link", "code", "paste", "table", "lists"],
        toolbar: ["undo redo cut copy paste bold italic underline numlist bullist fontsizeselect | alignleft alignright aligncenter | styleselect | image link unlink code "],
        image_advtab: true,
        style_formats_merge: true,
        paste_as_text: true,
        paste_data_images: true,
        relative_urls: false,
        remove_script_host: false,
        height: 400,
        style_formats: [{
          title: 'Image Left',
          selector: 'img',
          styles: {
            'float': 'left',
            'margin': '0 10px 0 10px'
          }
        },
          {
            title: 'Image Right',
            selector: 'img',
            styles: {
              'float': 'right',
              'margin': '0 0 10px 10px'
            }
          },
          {
            title: 'GP Heading',
            block: 'div',
            classes: 'tile_title'
          }
        ]
      },
      filters: [{label: "All Open", value: "open"},
        {label: "Opened By Me", value: "mine"},
        {label: "All Closed", value: "closed"},
        {label: "Open Bugs", value: "openbug"},
        {label: "Open Enhancements", value: "openenhance"},
        {label: "Closed Bugs", value: "closedbug"},
        {label: "Closed Enhancements", value: "closedenhance"},
        {label: "In Progress", value: "progress"},
        {label: "Ready for Release", value: "ready"}
      ],
      statuses: [{text: "Open", value: "Open"},
        {text: "Submitted", value: "Submitted"},
        {text: "Future", value: "Future"},
        {text: "Closed", value: "Closed"},
        {text: "Rejected", value: "Rejected"},
        {text: "Duplicate", value: "Duplicate"},
        {text: "Implemented", value: "Implemented"},
        {text: "In Consideration", value: "In Consideration"},
        {text: "In Progress", value: "In Progress"},
        {text: "Ready for Release", value: "Ready for Release"}],
      priorities: [{text: "1-Critical", value: "1-Critical"},
        {text: "2-High", value: "2-High"},
        {text: "3-Medium", value: "3-Medium"},
        {text: "4-Low", value: "4-Low"},
        {text: "5-N/A", value: "5-N/A"}],
      types: [{text: "Bug/Defect", value: "Bug"}, {text: "Enhancement/Feature Request", value: "Enhancement"}],
      enteredFrom: ""
    };

  },
  mounted() {
    if (this.$route.params.id) {
      this.forceQuery = "id:" + this.$route.params.id
    }
    if (this.$route.params.action == "report") {
      this.resetNewIssue()
      this.showList = false
      this.showCreate = true
    }
    document.title = "Issues";
    api.get("/public/version").then(
      (results) => {
        this.release = results.data.backend
        this.uiRelease = results.data.frontend
      },
      (error) => {
        this.$notify.error({message: error.response.data, timeOut: 6000})
      }).then(() => {
      this.$store.dispatch("setExecuting", false)
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollListener)
  },
  methods: {
    forcedRowLoaded(row) {
      this.forceQuery = null
      this.viewIssue(row)
    },
    handleRowAction(row, action) {
      if (action == "view") this.viewIssue(row)
    },
    openNewIssue() {
      this.resetNewIssue()
      this.showList = false
      this.showCreate = true
      this.listScrollPos = 0
    },
    resetNewIssue() {
      this.newIssue = {type: "Bug", title: "", description: ""}
    },
    toggleVote(info) {
      info.voted = !info.voted
      if (info.voted) info.votes++
      else info.votes--
      this.saveUserInfo(info)
    },
    toggleFollowing(info) {
      info.watch = !info.watch
      this.saveUserInfo(info)
    },
    saveUserInfo(info) {
      this.$store.dispatch("setExecuting", true)
      let url = "/issue/userInfo/" + this.currentIssue.id
      api.post(url, info).then(
        (results) => {

        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 6000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    saveIssue(silent) {
      this.$store.dispatch("setExecuting", true)
      let url = "/issue/update/" + this.currentIssue.id
      this.currentIssue.isSilent = silent
      api.post(url, this.currentIssue).then(
        (results) => {
          this.currentIssue.statusDate = results.data.statusDate
          this.$notify.success({message: "Updated Successfully", timeOut: 3000})
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 6000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    reportIssue() {
      this.$store.dispatch("setExecuting", true)
      let url = "/issue/report/"
      api.post(url, this.newIssue).then(
        (results) => {
          this.$notify.success({message: "Report Submitted Successfully", timeOut: 3000})
          this.$router.push("/issues/show/" + results.data.id)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 6000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    getStats: function () {
      this.$store.dispatch("setExecuting", true)
      let url = "/issue/stats/" + this.currentIssue.id
      api.get(url).then(
        (results) => {
          this.stats = results.data
          this.showStats = true
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    viewIssue: function (i) {
      this.currentIssue = i
      this.showList = false
      this.showIssue = true
      this.showCreate = false
      this.listScrollPos = window.scrollY
      this.$nextTick().then(() => {
        window.scrollTo(0, 0)
      })
    }
    ,
    issueList: function () {
      if (this.$route.params.id) {
        this.$router.replace("/issues")
      }
      this.currentIssue = null
      this.showList = true
      this.showIssue = false
      this.showCreate = false
      this.$nextTick().then(() => {
        window.scrollTo(0, this.listScrollPos)
      })
    }

  }
  ,
}
;
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
</style>
